//export const PATH = "https://arinet-strapi.herokuapp.com/api/";
//export const UPLOAD_PATH = "https://www.arinet.cloud/arinet";




const _PATH = isStaging() ? "https://arinet-strapi-staging-55c81b95a471.herokuapp.com/api/" : "https://arinet-strapi.herokuapp.com/api/";
export const PATH= _PATH;

const _UPLOAD_PATH = isStaging() ? "https://staging.codzilla.it/arinet" : "https://www.arinet.cloud/arinet";
export const UPLOAD_PATH = _UPLOAD_PATH;

const _PUBLIC_PATH = isStaging() ? "/staging" : "";
export const PUBLIC_PATH = _PUBLIC_PATH;


export const GOOGLE_API_KEY = "AIzaSyC-3gUZsi3dkacsLl7MqfKx1Aim_z2zZ8w";

export const FATTURE_PATH = "https://api-v2.fattureincloud.it";
export const FATTURE_API_KEY = "a/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyZWYiOiIwWHJCQ2c0YXc0R1dieDlVWG1nUURoZDRqZ05KSmY3diJ9.ciUJhk8LSjCI7b5Mtrx9fKVD3wiiuhjMoODWhVcYJQ0";
export const FATTURE_COMPANY_ID = "875845";



export const ROLES = {
    admin: "Admin",
    ufficio_tecnico:"Ufficio Tecnico",
    tecnico_di_cantiere:"Tecnico di cantiere",
    segreteria:"Segreteria",
    appalti:"Appalti",
    risorse_umane:"Risorse umane",
    PM:"PM",
}

export const STATUS_WORKER = [
    "ORDINARIO",
    "PERMESSO",
    "STRAORDINARI ",
    "FERIE",
    "MALATTIA",
    "ASSENZA",
    "SOSPESO",
    "NOTTURNO",
    "PATERNITA/MATERNITA"
]

export const UFFICIO_ID = 52;

export function isStaging() {
    //enable this to work on production db
    //return false

    if (window.location.toString().includes("localhost") || window.location.toString().includes("staging")) { return true }
    return false
}

export const CHECKLIST_COMMESSA= [
    {
        name: "Modulo di fine cantiere",
        type: "file"
    },
    {
        name: "Certificato di Regolare Esecuzione (CRE)",
        type: "file"
    },
    {
        name: "Certificazioni - DiCo",
        type: "file"
    },
    {
        name: "Certificato di Esecuzione Lavori (CEL)",
        type: "file"
    },
    {
        name: "Piano di manutenzione",
        type: "file"
    },
    {
        name: "Formulari Identificazione Rifiuti (FIR)",
        type: "file"
    }
]